class LxCollectionPagination extends HTMLElement {
  connectedCallback() {
    // Wait until the section's children exist, including after a facet replacement.
    queueMicrotask(() => {
      if (this.isConnected && !this.infiniteScroll) this.initialize();
    });
  }

  initialize() {
    const collection = this.closest('.collection');
    this.grid = collection?.querySelector('#product-grid');
    if (!this.grid) return;

    const startPage = Number(this.dataset.currentPage) || 1;
    const totalPages = Number(this.dataset.totalPages) || 1;
    this.totalItems = Number(this.dataset.totalItems) || 0;
    this.updateProgress();

    const button = this.querySelector('.view-more-button');
    const buttonContainer = this.querySelector('.load-more-container');
    const navigation = collection.querySelector('.pagination');

    if (startPage >= totalPages || !this.dataset.nextUrl) {
      if (buttonContainer) buttonContainer.style.display = 'none';
      return;
    }

    if (!window.InfiniteScroll) {
      if (buttonContainer) buttonContainer.style.display = 'none';
      return; // Keep ordinary pagination available if the library cannot load.
    }

    // Shopify's next-page URL belongs to this rendered result set, even if
    // another filter request has already changed the address bar.
    const nextUrl = new URL(this.dataset.nextUrl, window.location.href);
    nextUrl.searchParams.delete('section_id');
    this.requestController = new AbortController();

    this.infiniteScroll = new window.InfiniteScroll(this.grid, {
      path: function () {
        const page = startPage + this.loadCount + 1;
        if (page > totalPages) return undefined;
        const url = new URL(nextUrl);
        url.searchParams.set('page', page);
        return url.pathname + url.search;
      },
      append: '.collection-grid-item',
      outlayer: false,
      hideNav: navigation,
      status: this.querySelector('.page-load-status'),
      button: button,
      scrollThreshold: button ? false : 400,
      // Facets owns browser history; loading more must not replace its state.
      history: false,
      fetchOptions: { signal: this.requestController.signal },
      onInit: function () {
        this.pageIndex = startPage;
      },
    });

    this.infiniteScroll.on('append', () => {
      if (this.isConnected) this.updateProgress();
    });
    this.infiniteScroll.on('last', () => {
      if (this.isConnected && buttonContainer) buttonContainer.style.display = 'none';
    });
  }

  updateProgress() {
    const currentItems = this.grid.querySelectorAll('.collection-grid-item').length;
    const percent = this.totalItems ? Math.min((currentItems / this.totalItems) * 100, 100) : 0;
    const bar = this.querySelector('#progress-bar-fill');
    const text = this.querySelector('#progress-text');
    if (bar) bar.style.width = `${percent}%`;
    if (text) text.textContent = `Showing ${currentItems} of ${this.totalItems} products`;
  }

  disconnectedCallback() {
    this.requestController?.abort();
    if (this.infiniteScroll) {
      // A response already resolved when abort runs must not append old cards.
      this.infiniteScroll.canLoad = false;
      this.infiniteScroll.option({ append: false });
      this.infiniteScroll.destroy();
      this.infiniteScroll = null;
    }
  }
}

if (!customElements.get('lx-collection-pagination')) {
  customElements.define('lx-collection-pagination', LxCollectionPagination);
}
